import React, { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductSection from './components/ProductSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';
import CallMeDialog from './register';
import img1 from './images/kits/k1.jpeg';
import img2 from './images/kits/k2.jpeg';
import img3 from './images/kits/k3.jpeg';
import kit2 from './images/kits/kit2.jpg';
import { useNavigate, useParams } from 'react-router';
import axios from 'axios';
import { Product } from './types';
function Products()
{
    return (    
    <div className="min-h-screen">
      <Header />      
      <main>        
        {/* Intro Section */}
        <section className="py-24 bg-black">
          <ProductSection />
        </section>        
      </main>
      <Footer />
    </div>
  );  
}

export default Products;
